import MenuItem from '@material-ui/core/MenuItem';
import PropTypes from 'prop-types';
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { TextField } from '../AuthenticationForm';

const birthYears = [];
const thisYear = new Date().getFullYear();
for (let i = thisYear - 1; i > thisYear - 99; i -= 1) {
  birthYears.push(new Date(i, 0, 1));
}

const styles = {
  selectLabel: {
    color: '#808080',
    fontSize: 16,
  },
};

class BirthdayFieldComponent extends React.Component {
  static propTypes = {
    classes: PropTypes.objectOf(PropTypes.string).isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.shape({}),
  };

  static defaultProps = {
    value: null,
  };

  handleChange = (e) => {
    const {
      target: { name, value },
    } = e;
    this.props.onChange({
      target: { name, value: value ? new Date(value) : null },
    });
  };

  render() {
    const { classes, value, ...props } = this.props;
    return (
      <TextField
        select
        SelectProps={{ MenuProps: { className: classes.selectLabel } }}
        {...props}
        value={value ? value.toUTCString() : ''}
        onChange={this.handleChange}
      >
        <MenuItem value="" />
        {birthYears.map((year) => (
          <MenuItem className={classes.selectLabel} key={year} value={year.toUTCString()}>
            {year.getFullYear()}
          </MenuItem>
        ))}
      </TextField>
    );
  }
}

export const BirthdayField = withStyles(styles)(BirthdayFieldComponent);
